import React from 'react';

import { withFirebase } from '../firebase';

const ClassificationTableItem = (props) => {

    const { team, index } = props;

    const borderLeftClass = (team.group && index < 3) ? "border-left border-3 border-success" : ""
    const goals = (team.goalsF || '0') + ":" + (team.goalsC || '0');
    const difGoals = team.goalsF != null && team.goalsC != null ? team.goalsF - team.goalsC : '0';

    const teamLogo = (team && team.logoUrl) ? team.logoUrl : process.env.PUBLIC_URL + "/team_logo.png"

    const gpe = `${(team.wins) || '0'}:${(team.lost) || '0'}:${(team.draw) || '0'}`;

    return (
        <tr className={borderLeftClass}>
            <th className="align-middle text-center" scope="row" >{index}</th>
            <th className="align-middle text-right">
                <div style={{
                    backgroundImage: `url(${teamLogo})`,
                    height: 30,
                    width: 30,
                    minWidth: 30,
                    backgroundPosition: 'center',
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat'
                }} />
            </th>
            <td className="align-middle">{team.title}</td>
            <td className="align-middle text-secondary text-center">{(team.played) || '0'}</td>
            <td className="align-middle text-secondary text-center">{gpe}</td>
            {/* <td className="align-middle text-secondary text-center">{(team.wins) || '0'}</td>
            <td className="align-middle text-secondary text-center">{(team.lost) || '0'}</td>
            <td className="align-middle text-secondary text-center">{(team.draw) || '0'}</td> */}
            <td className="align-middle text-secondary text-center d-none d-sm-table-cell">{goals}</td>
            <td className="align-middle text-secondary text-center d-none d-sm-table-cell">{difGoals}</td>
            <td className="align-middle text-center">{(team.points) || '0'}</td>

        </tr>
    )

}

export default withFirebase(ClassificationTableItem);
